module.exports = __webpack_public_path__ + "img/zhuanpan_top.9c65c195.png";